import React, { useState } from 'react';
import {CardNumberElement, CardExpiryElement, CardCvcElement, useStripe, useElements} from '@stripe/react-stripe-js';
import Input from '../../form/Input';
import SelectInput from '../../form/select';
import Very from '../../../helpers/request_wrapper'

const useFormState = (init = {}) => {
  const [ state, setState] = useState(init);
  function setNewState(changeset) {
    setState({ ...state, ...changeset})
  }
  return [state, setNewState];
};

export default function CreditCardForm(props) {
  const { CountryOptions } = props;
  const stripe = useStripe();
  const elements = useElements();
  const [customer, setCustomer] = useFormState(props.customer);
  const [ processing, setProcessing ] = useState(false);
  const [ error, setError ] = useState(null);

  const addCard = async(e) => {
    setProcessing(true);
    setError(null);
    e.preventDefault();
    console.log(customer);
    const cardElement = elements.getElement(CardNumberElement);
    const res = await stripe.createToken(cardElement);

    if (res.error) {
      setProcessing(false);
      setError(res.error.message);
      return;
    }
    Very.post('/cards', { customer, token: res.token.id}).then(response => {
      setCustomer(response);
      window.location.reload();
    }, error => {
      setError(error.data)
    })
  };

  return (
    <>
      <form onSubmit={addCard}>
        <div className="mb-20">
          <CardNumberElement />
        </div>

        <div className="flex mb-30 mxn-10">
          <div className="col-6 px-10">
            <CardExpiryElement />
          </div>

          <div className="col-6 px-10">
            <CardCvcElement />
          </div>
        </div>

        <div className="mx-auto" style={{ maxWidth: '370px' }}>
          <div className="mb-20">
            <Input
              label="Billing name"
              required
              value={customer && customer.name}
              onChange={(name) => setCustomer({ name })}
            />
          </div>

          <div className="mb-20">
            <Input
              label="Street address"
              value={customer && customer.address}
              required
              onChange={(address) => setCustomer({ address })}
            />
          </div>

          <div className="flex mb-20 mxn-10">
            <div className="col-6 px-10">
              <Input
                value={customer && customer.postal_code}
                label="ZIP / Postal code"
                onChange={(postal_code) => setCustomer({ postal_code })}
              />
            </div>

            <div className="col-6 px-10">
              <Input
                required
                label="City"
                value={customer && customer.city}
                onChange={(city) => setCustomer({ city })}
              />
            </div>
          </div>

          <div className="mb-30">
            <SelectInput
              className="react-select"
              name="countries"
              value={customer.country}
              onChange={(country) => setCustomer({ country: country.value })}
              options={CountryOptions}
              placeholder="Country"
              required
            />
          </div>
        </div>

        {error && <p className="text-violet-red mb-20">{error}</p>}

        <div className="mb-10">
          {processing ?
            <p>Processing your card...</p>
            :
            <input
              className="btn btn--primary col-12 mb-20"
              type="submit"
              value="Save"
            />
          }
        </div>


      </form>
    </>
  )
}